import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import moment from "moment";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  month: number;
  year: number;
  data: { label: string; value: string }[];
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  month: moment().month() + 1,
  year: moment().year(),
  data: [],
};

const getListRequestLeaveManagerSlice = createSlice({
  name: "getListRequestLeaveManager",
  initialState,
  reducers: {
    setMonthYearListRequestLeaveManager: (
      state,
      action: PayloadAction<{ month: number; year: number }>
    ) => {
      state.month = action.payload.month;
      state.year = action.payload.year;
    },
    getListRequestLeaveManagerStart: (state, action: PayloadAction<object>) => {
      state.status = ReduxStateType.LOADING;
    },
    getListRequestLeaveManagerSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getListRequestLeaveManagerFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    updateListRequestLeaveManager: (state, action) => {
      state.data = action.payload;
    },
    resetListRequestLeaveManager: () => {
      return { ...initialState };
    },
  },
});

export const {
  setMonthYearListRequestLeaveManager,
  getListRequestLeaveManagerStart,
  getListRequestLeaveManagerSuccess,
  getListRequestLeaveManagerFailed,
  resetListRequestLeaveManager,
  updateListRequestLeaveManager,
} = getListRequestLeaveManagerSlice.actions;

export default getListRequestLeaveManagerSlice.reducer;
